export enum StateVisitEnum {
  Pending = 1,
  Realized = 2,
  Canceled = 3
}
